<div class="content-wrapper">
  <div class="page-heading d-flex align-items-start gap-4">
    <button class="btn btn-primary" (click)="goBack()">
      <i
        class="fa-solid fa-arrow-left"
        data-bs-toggle="Tooltip"
        title="Go Back"
      ></i>
    </button>
    <div class="">
      <h2>{{ section?.title }}</h2>
      <p class="expandable-section-heading-des">
        {{ section?.content }}
      </p>
    </div>
  </div>
  <app-rules [rules]="section?.subContents"></app-rules>
</div>
<div *ngIf="!sections.length">
  <app-loader></app-loader>
</div>
